import { useCallback, useEffect, useState } from "react";
import { forceRefreshPage } from "../../util";
export const NewAppVersionSentinel = ({ versionUrl, currentVersion, renderChild, onVersionFetchError, }) => {
    const [isAvailable, setIsAvailable] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(true);
    const checkNewVersion = useCallback(async () => {
        if (!isRefreshing)
            return;
        const latestVersion = await fetch(versionUrl, {
            cache: "no-store",
        })
            .then((resp) => {
            if (!resp.ok) {
                return undefined;
            }
            return resp.text();
        })
            .then((text) => text?.trim())
            .catch((e) => {
            onVersionFetchError(e);
            return undefined;
        });
        if (latestVersion === undefined || currentVersion === undefined) {
            return;
        }
        else if (latestVersion !== currentVersion) {
            setIsAvailable(true);
            setIsRefreshing(false);
        }
    }, [isRefreshing, versionUrl, currentVersion]);
    useEffect(() => {
        if (!isRefreshing)
            return;
        checkNewVersion();
        const milliseconds = 50 * 1000;
        const intervalId = setInterval(checkNewVersion, milliseconds);
        return () => clearInterval(intervalId);
    }, [isRefreshing, checkNewVersion]);
    if (!isAvailable)
        return null;
    return renderChild(forceRefreshPage);
};
//# sourceMappingURL=NewAppVersionSentinel.js.map